import { Button, InputText } from "@sellar-io/components";
import { ReactElement, useState } from "react";
import { InputLabel, InputContainer } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";

export const IntegrationDeactivationModal = ({
  active,
  onDismiss,
  title,
  subtitle,
  onSubmit,
  loading,
}: {
  active: boolean;
  title: string;
  onDismiss: () => void;
  onSubmit: () => void;
  subtitle: string;
  loading: boolean;
}): ReactElement => {
  const [deactivationTextInput, setDeactivationTextInput] = useState("");

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={title}
        description={subtitle}
      />
      <DialogContent className={"flex flex-col gap-2"}>
        <InputLabel>Type the word 'DEACTIVATE' to confirm</InputLabel>
        <InputContainer>
          <InputText
            value={deactivationTextInput}
            onChange={(e) => setDeactivationTextInput(e.target.value)}
            placeholder={"DEACTIVATE"}
            required={true}
          />
        </InputContainer>
      </DialogContent>
      <DialogCTA>
        <Button
          color={"red"}
          loading={loading}
          disabled={deactivationTextInput !== "DEACTIVATE"}
          onClick={() => {
            if (deactivationTextInput === "DEACTIVATE") {
              onSubmit();
            }
          }}
        >
          Deactivate
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
